import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20shapes%20in%20coral%20and%20deep%20warm%20tones%2C%20modern%20technology%20theme%2C%20elegant%20and%20minimal%20composition%2C%20smooth%20curves%2C%20cinematic%20atmosphere&width=1920&height=800&seq=cta-bg-4688&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50" />

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
            准备好开启您的视听新世界了吗？
          </h2>
          <p className="text-sm md:text-base text-white/70 mb-8 leading-relaxed">
            立即注册 4688.tv，享7天免费会员体验。海量高清内容、独家原创节目、AI 智能推荐，
            为您打造专属的娱乐空间。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="#"
              className="px-8 py-3.5 bg-primary-500 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap transform hover:scale-105"
            >
              免费注册体验
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white text-sm md:text-base font-medium rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap border border-white/20"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}